import React from "react"
import {range} from "lodash"
import PropTypes from "prop-types"

import './Reservation.Persons.less'

export default class PersonsPicker extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { showMore: false }
  }
  

  render() {
    const { onChange, value} = this.props
    return  (
      <div className="personsContainer" id="PersonsPicker">
        {range(1, this.state.showMore || value >= 10 ? 30 : 10).map(number => (
          <div 
            key={number} 
            className={`number ${number === value ? "selected" : ""}`} 
            onClick={() => {
              onChange(number)
            }}
          >
            {number}
          </div>))
        }
        {!this.state.showMore && value < 10 && (
          <div 
            className={`number`} 
            onClick={() => {
              this.setState({showMore: true})
            }}
          >
          更多
          </div>)}
      </div>
    )
  }
}

PersonsPicker.propTypes = {
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func, 
}



// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/Reservation.Persons.jsx